import { Token } from '@domain/entities/session.entity';
import { MasterTokenDTO } from '../dtos/session.dto';

// Maps between the API DTO and the Domain Entity
export class MasterTokenMapper {
  toDomain(dto: MasterTokenDTO): Token {
    return {
      token: dto.token,
    };
  }
}
